
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns3a2875cc658ce6acf1e68576b36b4c66en from './en.yaml'
            i18n.addResourceBundle('en', '3a2875cc658ce6acf1e68576b36b4c66', flattenObject(ns3a2875cc658ce6acf1e68576b36b4c66en), true, true);
        
        export default '3a2875cc658ce6acf1e68576b36b4c66';
    